<template>
  <div>
    <keep-alive>
    <draggable
      ref="drag"
      v-click-outside="hide"
      class="row e-draggable"
      :class="{'e-draggable--active': canDrag}"
      :move="move"
      v-model="components"
      :options="options">
        <component
          v-for="(component, i) in components"
          class="e-draggable__item"
          :class="{'e-draggable__target': dragId === component.id}"
          @toggleDrag="() => toggleDrag(component.id)"
          :size="component.size"
          :is="component.component"
          :key="component.id"/>
    </draggable>
    </keep-alive>

  </div>
</template>

<script>
  import draggable from 'vuedraggable';
  import ClickOutside from 'vue-click-outside'
  import _ from 'lodash';

  export default {
		name: "e-draggable",
    directives: {
      ClickOutside
    },
    components: { draggable },
    props: {
		  target: {
		    type: Array,
        required: true,
      }
    },
    computed: {
		  components: {
		    get() {
          // const minRows = Math.ceil(this.components.reduce((p, c) => p + c.sizes.large.min, 0) / 12);
          const rows = [];

          let temp = 0;
          let tempI = 0;

          _.sortBy(this.rootTarget, 'position').forEach(c => {
            if (temp + c.sizes.large.min <= 12) {
              if (!rows[tempI]) {
                rows[tempI] = [];
              }
            } else {
              tempI++;
              temp = 0;
              if (!rows[tempI]) {
                rows[tempI] = [];
              }
            }
            temp += c.sizes.large.min;
            rows[tempI].push({
              id: c.id,
              component: c.component,
              position: c.position,
              size: c.sizes.large.min,
              diff: c.sizes.large.max - c.sizes.large.min,
              sizes: c.sizes,
            });
          });

          rows.forEach(row => {
            let diff = 12 - row.reduce((p, c) => p + c.size, 0);

            if (diff !== 0) {
              let sorted = _.sortBy(row, 'diff');
              // let flag = true;

              while (diff !== 0 && sorted.some(e => e.diff > 0)) {
                sorted.forEach((c, i) => {
                  if (c.diff !== 0) {
                    sorted[i].size++;
                    sorted[i].diff--;
                    diff--;
                  }
                });
              }
            }
          });

          // this.rowsState = rows;
          // console.log(_.flatten(rows));
          return _.flatten(rows);
        },
        set(v) {
		      let newPositions = v.map((c, i) => {
		        return {
              ...c,
              position: i + 1
            };
		      });

		      this.$emit('change', newPositions);
          // this.rootTarget = newPositions;
        }
      },
      options() {
        return {
          group: 'sample',
          animation: 150,
          forceFallback: true,
          // draggable: '.e-draggable__target',
          // draggable: '.e-draggable__item',
          // handle: 'e-draggable__item',
          disabled: !this.canDrag,
          // disabled: false,
        }
      },
    },
    methods: {
		  move(evt) {
		    return evt.draggedContext.element.id === this.dragId;
      },
      hide() {
        this.canDrag = false;
      },
      toggleDrag(id) {
        // console.log(this.$refs.dragItems[i]);
        // this.$refs.dragItems[i]
        this.dragId = id;
        this.canDrag = !this.canDrag;
      }
    },
    watch: {
		  'target': {
		    handler(current, old) {
		      this.rootTarget = current;
        }
      }
    },
    data() {
		  return {
        canDrag: false,
        rootTarget: _.clone(this.target, true),
        dragId: null,
        // components: _.clone(this.target, true),
        // rowsState: [],
      }
    },
    mounted() {

    }
  }
</script>

<style lang="scss">
  .e-draggable {
    .e-draggable__item {
      margin-bottom: 30px;
    }

    .e-draggable__target {
      .e-card__container {
        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          padding: 1px 0;
          display: block;
          height: 100%;
          border-left: 2px solid #1875f0;
        }
      }
    }

    &.e-draggable--active {
      transition: all ease 200ms;
      /*background: rgba(159, 180, 211, 0.21);*/
      padding-top: 15px;
      margin-top: -15px;
      border-radius: 4px;

      .sortable-ghost {
        opacity: 0.3 !important;

        .e-card__container {
          &:before {
            display: none !important;
          }
        }

        .tabs {
          transition: filter ease 200ms;
          filter: grayscale(100%);
        }
      }

      .sortable-fallback {
        opacity: 1 !important;
      }

      .sortable-chosen {
        opacity: 0.99;

        .e-card__container {
          &:before {
            content: '';
            position: absolute;
            top: -1px;
            left: -1px;
            padding: 1px 0;
            display: block;
            height: 100%;
            border-left: 2px solid #1875f0;
          }
        }
      }

      .e-card {
        .e-card__container {
          /*border: 2px dashed #0a2c58;*/

          /*.tabs {*/
            /*transition: all ease 200ms;*/
            /*filter: grayscale(100%);*/
          /*}*/

          &:before {
            transition: opacity ease 200ms;
            display: block;
            width: 100%;
            height: 100%;
            position: absolute;
            content: "";
            z-index: 10000;
            /*background: rgba(10, 44, 88, 0.24);*/
          }
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
    .e-draggable {
      margin-left: -8px;
      margin-right: -8px;

      .e-draggable__item {
        padding-left: 8px;
        padding-right: 8px;
        margin-bottom: 16px;
      }

      &.e-draggable--active {
        padding-top: 0;
        margin-top: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/elements/draggable/draggable.vue